import { GlobalApproval } from './GlobalApprovals.types';

/*
 * Closed approvals read as done, anything GLOBAL or the client still has to
 * act on as pending.
 */
export function statusColor(approval: GlobalApproval): string {
  if (!approval.status) return '';
  return approval.status === 'Closed' ? 'success' : 'warning';
}

// A request turned down in whole reads as a problem, in part as a warning.
export function outcomeColor(approval: GlobalApproval): string {
  if (approval.outcome === 'Refused') return 'danger';
  if (approval.outcome) return 'warning';
  return '';
}
